export default "__VITE_ASSET__CfKAg4U5__"